// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TcZF","colBig":"styles_colBig__1-Rqg","colSmall":"styles_colSmall__3KYgX"};